import {RestService} from "@sinossi/mates-react-library";

export class SessionService {
    static getSession = (callback: any, catchCallback: any) => {
        RestService
            .get<any>("/api/session")
            .then(callback)
            .catch(catchCallback)
    }
}
